var DevOps = "DevOps";
var Gaming = "Jeux";
var Migration = "Migration";
var Other = "Autre";
var useCase = {
	"Use case": "Cas d'utilisation",
	"AI & machine learning": "IA (Intelligence artificielle) et Machine Learning",
	"Batch processing": "Traitement par lots",
	"Big data, analytics, & business intelligence": "Big Data, analytique et informatique décisionnelle",
	"Business applications - Microsoft": "Applications métier - Microsoft",
	"Business applications - Oracle": "Applications métier - Oracle",
	"Business applications - Other": "Applications métier - Autre",
	"Business applications - SAP": "Applications métier - SAP",
	"Content delivery": "Diffusion de contenu",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Internet des objets",
	"Learning & certification": "Formation et certification",
	"Media services": "Services multimédias",
	Migration: Migration,
	"Mobile applications": "Applications mobiles",
	Other: Other,
	"Storage & backup": "Stockage et sauvegarde",
	"Websites & web apps": "Sites et applications Web"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
